import {call, put} from 'redux-saga/effects';

import axios from 'axios';
import * as lexActionType from '../actionsType/lexLicenseMode.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

function requestLicense(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/lp/requestLexLicense`,
        data: reqObj
    });
}

// function requestLicense(reqObj) {
//     return axios({
//         method: 'get',
//         url: 'http://localhost:3004/response',
//         data: reqObj
//     });
// }


export function* fetchRequestLicenseSaga(request) {
    try {
        const response = yield call(requestLicense, request.payload);
        // const content = response.data.status;
        const content = response.data.status;
        yield put({
            type: lexActionType.LEX_LICENSE_MODE_REQUEST_SUCCESS,
            payload: content
        });
    } catch (error) {
        yield put({
            type: lexActionType.LEX_LICENSE_MODE_REQUEST_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}
